/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface OrphanedSessionDto
 */
export interface OrphanedSessionDto {

    /**
     * The session
     *
     * @type {JoinEntityDto}
     * @memberof OrphanedSessionDto
     */
    event: JoinEntityDto;

    /**
     * Title of the session, for the message
     *
     * @type {string}
     * @memberof OrphanedSessionDto
     * @example Seduta 5
     */
    title: string;

    /**
     * Where the session WOULD be after the edit — already shifted when the start date moves, since `startAt` translates the whole plan
     *
     * @type {string}
     * @memberof OrphanedSessionDto
     */
    start: string;

    /**
     * @type {string}
     * @memberof OrphanedSessionDto
     */
    end: string | null;
}
